import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Message from './Message';
import Typing from './Typing';
import FileMessage from './files/FileMessage';

const ChatMessages = ({typing}) => {

    const {messages,activeConversation} = useSelector((state) => state.chat);
    const {user} = useSelector((state)=>state.user);
    const endRef = useRef();
    useEffect(()=>{
        endRef.current.scrollIntoView({behavior:"smooth"});
    },[messages])
    const getIsLastInGroup = (idx) => {
      if (!messages || idx >= messages.length) return true;
      const curr = messages[idx];
      const next = messages[idx + 1];
      if (!next) return true;
      const currSender = curr?.sender?._id;
      const nextSender = next?.sender?._id;
      return currSender !== nextSender;
    };

    const getReplyPreview = (message) => {
      const replyId = message?.metadata?.replyToMessageId || null;
      const replyIndex = Number.isFinite(message?.metadata?.replyToMessageIndex)
        ? message.metadata.replyToMessageIndex
        : null;
      let replied = null;
      if (replyId) {
        replied = messages.find((m) => m?.metadata?.platformMessageId === replyId);
      }
      if (!replied && replyIndex !== null && messages[replyIndex]) {
        replied = messages[replyIndex];
      }
      if (!replied) return null;
      const text = replied.message || '';
      const type = (replied?.metadata?.messageType || 'text').toLowerCase();
      return text || `[${type}]`;
    };

    const hasToolImages = (message) => {
      const toolCalls = message?.toolCalls || [];
      return toolCalls.some((tc) => tc?.name === 'send_images');
    };

    const shouldRenderMessage = (message) => {
      const content = message?.message || message?.content || '';
      if (content.length > 0) return true;
      const type = (message?.metadata?.messageType || '').toLowerCase();
      const placeholderType = content.trim().match(/^\[(image|video|audio|voice|document|sticker)\]$/i);
      const hasImageUrl = /\[Image URL:\s*[^\]]+\]/i.test(content);
      return ['image','video','audio','voice','document','sticker','location','contact','interactive'].includes(type)
        || !!placeholderType
        || hasImageUrl
        || hasToolImages(message);
    };

    const isSameDay = (a, b) => {
      if (!a || !b) return false;
      const da = new Date(a);
      const db = new Date(b);
      return da.getFullYear() === db.getFullYear()
        && da.getMonth() === db.getMonth()
        && da.getDate() === db.getDate();
    };

    const getDayLabel = (dateValue) => {
      if (!dateValue) return '';
      const d = new Date(dateValue);
      const now = new Date();
      const yesterday = new Date();
      yesterday.setDate(now.getDate() - 1);
      if (isSameDay(d, now)) return 'اليوم';
      if (isSameDay(d, yesterday)) return 'أمس';
      return d.toLocaleDateString('ar-EG', { year: 'numeric', month: 'long', day: 'numeric' });
    };

    return (
        <div className="mb-[60px] bg-[url('/public/bg.jpg')]
        bg-cover bg-no-repeat">
            <div className='scrollbar overflow_scrollbar overflow-auto py-2 px-3'>
            {messages &&
          messages.map((message, msgIdx) => {
            const prev = messages[msgIdx - 1];
            const showDivider = !prev || !isSameDay(message?.createdAt, prev?.createdAt);
            const me = user?._id && message?.sender?._id ? user._id === message.sender._id : false;
            const isLastInGroup = getIsLastInGroup(msgIdx);
            const hasText = message?.message?.length > 0;
            const files = message?.files || [];
            const replyPreview = getReplyPreview(message);
            return (
            <React.Fragment key={message._id}>
              {showDivider && (
                <div className="w-full flex justify-center my-2">
                  <span className="text-xs px-3 py-1 rounded-full bg-dark_bg_2 text-dark_text_2 border border-dark_border_1">
                    {getDayLabel(message?.createdAt)}
                  </span>
                </div>
              )}
              {/*Message files */}
              {files.length > 0
                ? files.map((file, fileIdx) => (
                    <FileMessage
                      FileMessage={file}
                      message={message}
                      key={`${message._id}-file-${fileIdx}`}
                      me={me}
                      showAvatarAndTail={isLastInGroup && !hasText && fileIdx === files.length - 1}
                    />
                  ))
                : null}
              {/*Message text*/}
              {shouldRenderMessage(message) ? (
                <Message
                  message={message}
                  me={me}
                  showAvatarAndTail={isLastInGroup}
                  replyPreview={replyPreview}
                />
              ) : null}
            </React.Fragment>
          );
          })}
                {typing===activeConversation._id?<Typing/>:""}
                <div className='mb-2' ref={endRef}></div>
            </div>
        </div>
    );
}

export default ChatMessages;
